import React, { useState } from "react";

// Image with a blur-up canvas placeholder and fixed aspect ratio to prevent
// layout shift — the plan calls for aspect-ratio boxes + lazy-load below fold.
export default function PlantImage({ src, alt, ratio = "4/5", className = "", priority = false }) {
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  return (
    <div
      className={`relative overflow-hidden bg-forest-100 ${className}`}
      style={{ aspectRatio: ratio }}
    >
      {!loaded && !errored && <div className="absolute inset-0 skeleton" />}
      {errored ? (
        <div className="absolute inset-0 flex items-center justify-center bg-forest-100 text-forest-700">
          <span className="font-display text-2xl opacity-60">Fancy&nbsp;Plants</span>
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          onLoad={() => setLoaded(true)}
          onError={() => setErrored(true)}
          className={`h-full w-full object-cover transition-all duration-700 ${
            loaded ? "scale-100 blur-0 opacity-100" : "scale-105 blur-md opacity-0"
          }`}
        />
      )}
    </div>
  );
}
